import { useEffect, useState } from "react";

import useCustomSelector from "../../../redux/hooks/useCustomSelector";
import useActionCreator from "../../../redux/hooks/useActionCreator";

import { OfficeState } from "@reducers/types/inventory/office-state";

interface UseOfficeList {
  roomConfigOfficeState: OfficeState;
  handleQuery: (key: string, value: number | boolean | string) => void;
  setRefetch?: React.Dispatch<React.SetStateAction<{ refetch: boolean }>>;
}

export const useOfficeList = (forDropdown?: boolean): UseOfficeList => {
  const { officeFetchActionHandler } = useActionCreator();

  const [query, setQuery] = useState({
    page: 1,
    size: 10,
    search: "",
  });

  const [refetch, setRefetch] = useState({
    refetch: false,
  });

  const handleQuery = (key: string, value: number | boolean | string) =>
    setQuery((prev) => ({
      ...prev,
      [key]: value,
    }));

  const roomConfigOfficeState = useCustomSelector(
    (store) => store.inventory.roomConfigOfficeState,
  );

  useEffect(() => {
    if (forDropdown) {
      officeFetchActionHandler({
        page: 1,
        size: 100000,
        search: "",
      });
    } else {
      officeFetchActionHandler(query);
    }
  }, [query]);

  useEffect(() => {
    if (refetch.refetch) {
      officeFetchActionHandler({
        page: 1,
        size: 100000,
        search: "",
      });
    }
  }, [refetch]);

  return {
    handleQuery,
    roomConfigOfficeState,
    setRefetch,
  };
};
